module.exports = __webpack_public_path__ + "img/specialpricepage-location.53767531.png";